import { IconDefinition, faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { Box, Card, CardActionArea, CardContent, CardMedia, Grid, Typography, styled, useTheme } from "@mui/material";

const MenuItemCard = styled(Card)(({ theme }) => ({
  height: "100%",
  backgroundColor: theme.palette.dsPrimary.v300,
  color: theme.palette.common.white,
  fontSize: theme.spacing(5),
  "&:hover": {
    backgroundColor: theme.palette.dsPrimary.v200,
    color: theme.palette.common.black,
  },
  textAlign: "center",
  borderRadius: "4px",
  display: "flex",
}));

const MenuTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  whiteSpace: "break-spaces",
  [theme.breakpoints.up("xl")]: {
    fontSize: theme.spacing(3),
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: theme.spacing(3),
  },
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(3),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.spacing(2),
  },
}));

const MenuIcon = styled(Icon)(({ theme }) => ({
  width: "100% !important",
  height: "6vh",
  boxSizing: "border-box",
  [theme.breakpoints.down("sm")]: {
    width: "100% !important",
    height: "4vh",
  },
}));

const LockIcon = styled(Icon)(({ theme }) => ({
  position: "absolute",
  width: `${theme.spacing(6)} !important`,
  height: theme.spacing(6),
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: 2,
  color: "grey",
  [theme.breakpoints.down("lg")]: {
    width: `${theme.spacing(4)} !important`,
    height: theme.spacing(4),
  },
  [theme.breakpoints.down("md")]: {
    width: `${theme.spacing(3)} !important`,
    height: theme.spacing(3),
  },
}));

const LockedOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  background: "#020202",
  opacity: 0.5,
  zIndex: 1,
}));

interface IMenuItem {
  size: number;
  title: string;
  icon: IconDefinition;
  toolTip?: string;
  image?: string | null;
  locked?: boolean;
  disabled?: boolean;
  handler: () => void;
}

function MenuItem({ size = 2, title, image, icon, locked = false, disabled = false, handler }: IMenuItem) {
  const theme = useTheme();
  if (locked) disabled = true;
  return (
    <Grid item xs={size} sm={size} md={size} lg={size}>
      <MenuItemCard>
        <CardActionArea onClick={handler} disabled={locked}>
          <CardMedia image={!!image ? image : undefined} title={title}>
            <CardContent>
              <Box sx={{ paddingTop: theme.spacing(2) }}>
                <MenuIcon icon={icon} />
                {locked ? <LockedOverlay /> : null}
                {locked ? <LockIcon icon={faLock} /> : null}
                <MenuTitle>{title}</MenuTitle>
              </Box>
            </CardContent>
          </CardMedia>
        </CardActionArea>
      </MenuItemCard>
    </Grid>
  );
}

export default MenuItem;
